var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Dropdown",
    width: 24,
    height: 24,
    "data-name": "Icon - Dropdown",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__play001_-_E09A",
    fill: "#383838",
    d: "M-13.59-46.38v10l6-5z",
    "data-name": "play001 - E09A",
    transform: "rotate(90 -25.985 -3.395)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownBlack);
export default __webpack_public_path__ + "static/media/icon-dropdown-black.c6d0560154c36c70767eecdc5f136b59.svg";
export { ForwardRef as ReactComponent };